<div class="recap-section">
  <h3><b>RAPPEL DE LA COMMANDE</b></h3>
  <div class="small-margin recap-info">
    <div class="float-right">{{ currentResa ? currentResa.price : 0 }} € HT</div>
    <div>Prix unitaire par apprenant:</div>
  </div>
  <div class="small-margin recap-info">
    <div class="float-right">{{ currentResa ? currentResa.nb_places_reserve : 0 }}</div>
    <div>Nombre de participant:</div>
  </div>
  <div class="small-margin recap-info">
    <div class="float-right">{{ currentResa ? currentResa.price * currentResa.nb_places_reserve : 0 }} € HT</div>
    <div>Total:</div>
  </div>
  <div class="full-size align-right">
    <button kendoButton [primary]="true" class="colored-text small-margin align-left" (click)="downloadPrc()" [disabled]="downloadingPrc || confirmingOrder">
      <ng-container *ngIf="!downloadingPrc; else loadingText">TELECHARGER<br />ma proposition commerciale</ng-container>
      <ng-template #loadingText>TELECHARGEMENT<br />ma proposition commerciale</ng-template>
    </button>
    <button kendoButton class="colored-text small-margin align-left" (click)="confirmOrder()" [disabled]="downloadingPrc || confirmingOrder">
      VALIDER<br />la commande
    </button>
  </div>
</div>

<!--<div class="list-section">-->
<!--<h3><b>RAPPEL DES PARTICIPANTS</b></h3>-->

<!--<kendo-grid [data]="currentResa ? currentResa.participants : []" class="no-border">-->
<!--<kendo-grid-column field="id" title="ID" width="10" [headerClass]="'no-border'" [class]="'no-border'">-->
<!--</kendo-grid-column>-->
<!--<kendo-grid-column field="name" title="Nom" width="200" [headerClass]="'no-border'" [class]="'no-border'">-->
<!--</kendo-grid-column>-->
<!--<kendo-grid-column field="firstName" title="Prénom" [headerClass]="'no-border'" [class]="'no-border'">-->
<!--</kendo-grid-column>-->
<!--<kendo-grid-column field="mail" title="Email" width="150" [headerClass]="'no-border'" [class]="'no-border'">-->
<!--</kendo-grid-column>-->
<!--</kendo-grid>-->
<!--</div>-->

<!-- Clique sur le bouton valider et tout est ok -->
<lib-ags-kendo-window-titlebar
  *ngIf="bConfirm"
  (output)=terminateOrder()
  title="Confirmation"
  msgText='Votre commande est validée, vous pouvez la retrouver dans la rubrique "Mes propositions commerciales" de votre espace client.'>
</lib-ags-kendo-window-titlebar>

<!-- Clique sur le bouton valider et on n'a plus de place disponible -->
<lib-ags-kendo-window-titlebar
  *ngIf="indispo"
  title="Places Indisponibles"
  msgText="Il ne reste que {{indispoInfo.nbPlaces}} places pour la formations du {{indispoInfo.date}} à {{indispoInfo.currentSession.site[0].ville}}, veuillez réduire le nombre de participant ou choisir une autre session de formation">
</lib-ags-kendo-window-titlebar>
